import styled from 'styled-components';

import {colors} from 'theme';

export const FooterContainer = styled.div`
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr 1fr;

    & > * {
        &:last-child {
            grid-column: -1 / 1;
        }
    }
`;

export const FormContainer = styled.div``;

export const FormItem = styled.div`
    padding-bottom: 20px;
`;

export const FormItemContainer = styled.div`
    padding-bottom: 20px;
`;

export const FormItemDescription = styled.div`
    font-size: 12px;
    padding: 35px 15px 0 15px;
`;

export const FormLabel = styled.div`
    font-size: 11px;
    padding-top: 5px;
    padding-left: 3px;
    color: #7d7d7d;
`;

export const RadioButtonContainer = styled.div`
    padding: 15px 0;
    display: flex;
    font-size: 12px;
    div {
        padding-right: 10px;
    }
`;

export const ImagePreview = styled.div`
    height: 160px;
    background: url('/img/template.png');
    background-size: contain;
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.05);
`;

export const ErrorMessage = styled.div`
    padding: 5px 0;
    font-size: 12px;
    color: ${colors.danger};
`;
